module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-step-2-1475c78eaec720668ea8b4d71ff94706.svg";